export const FragmentShaderPCSS = `
  return PCSS( shadowMap, shadowCoord );
`;